import { render } from "./ResetPassword.vue?vue&type=template&id=1ff97842"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=1ff97842&lang=scss"
script.render = render

export default script